<template>
  <div class="container center w100 relative-container">
    <div class="padded">
      <step-counter class="tablet" paso="1" />
      <wrap-container class="cascade w50">
        <form-validator>
          <wrap-container>
            <p
              id="titulo"
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.paso1.titulo"
            />
            <p
              id="subtitulo"
              class="titulo oscuro subtitulo"
              v-safe-html="config.pasos.paso1.subtitulo"
            />
          </wrap-container>

          <wrap-container class="grid-container grid-container--6-6">
            <select-autocomplete
              class="col1"
              v-model="model.lugarNacimiento"
              name="lugarNacimiento"
              label="País de nacimiento"
              subhint="Ingrese su país de nacimiento"
              :items="paises"
              :validationError="validarPaisNacimiento"
              required
              analyticsName="lugar de nacimiento"
              :analyticsTypology="config.analyticsTypology"
              quantumObfuscate
            />
            <civil-status
              class="col2"
              v-model="model.estadoCivil"
              quantumObfuscate
            />
          </wrap-container>

          <wrap-container v-if="model.estadoCivil === '1'">
            <section-label value="Datos del cónyuge" />
            <div class="grid-container grid-container--6-6">
              <text-input
                class="col1"
                label="Nombre"
                v-model="model.conyuge.nombre"
                name="conyuge.nombre"
                :required="true"
                analyticsName="conyuge nombre"
                :analyticsTypology="config.analyticsTypology"
                quantumObfuscate
              />
              <text-input
                class="col2"
                label="Apellido"
                v-model="model.conyuge.apellido"
                name="conyuge.apellido"
                :required="true"
                analyticsName="conyuge apellido"
                :analyticsTypology="config.analyticsTypology"
                quantumObfuscate
              />
            </div>
          </wrap-container>

          <wrap-container
            class="grid-container grid-container--6-6"
            v-if="model.estadoCivil === '1'"
          >
            <document-type
              class="col1"
              v-model="model.conyuge.tipoDoc"
              name="conyuge.tipoDoc"
              :forzarDNE="forzarDNE"
              quantumObfuscate
            />
            <dni-input
              class="col2"
              label="Número de documento"
              hint="Ej: 28956372"
              v-model="model.conyuge.numeroDoc"
              inputName="conyuge.numeroDoc"
              :required="true"
              maxlength="8"
              analyticsName="conyugue número de documento"
              quantumObfuscate
            />
          </wrap-container>

          <wrap-container>
            <section-label value="Domicilio particular" />
            <address-data-old
              v-model="model.domicilioParticular"
              :searchEncontesa="model.searchEncontesa"
              quantumObfuscate
            />
          </wrap-container>
          <step-navigator
            v-model="model"
            :store-action="this.doNext"
            analyticsName="continuar"
          />
        </form-validator>
      </wrap-container>
      <wrap-container class="cascade w50"></wrap-container>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { cuilGen, get } from "@/utils";
import { nacionalidades } from "../config/constants";
import { DO_PASO1 } from "../config/constants/action-types";
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import StepCounter from "@/components/core/StepCounter";
import SectionLabel from "@/components/core/SectionLabel";
import DniInput from "@/components/core/composite/DniInput";
import TextInput from "@/components/core/TextInput";
import DocumentType from "@/components/core/composite/combos/DocumentType";
import CivilStatus from "@/components/core/composite/combos/CivilStatus";
import AddressDataOld from "@/components/core/AddressDataOld";
import SelectAutocomplete from "@/components/core/custom/SelectAutocomplete.vue";
import StepNavigator from "@/components/core/StepNavigator";

export default {
  name: "Paso1",
  components: {
    WrapContainer,
    FormValidator,
    StepCounter,
    TextInput,
    SectionLabel,
    DniInput,
    DocumentType,
    CivilStatus,
    AddressDataOld,
    StepNavigator,
    SelectAutocomplete
  },
  data() {
    return {
      model: this.$store.getters.getPaso1(),
      paises: nacionalidades.map(e => {
        return { value: e.label, label: e.label };
      }),
      doNext: DO_PASO1,
      isProduction: PRODUCTION
    };
  },
  computed: {
    ...mapState({
      /**
       * Forzar el DNI a DNE del conyuge
       */
      forzarDNE: state => {
        return get(state, "forzarDNE['conyuge.numeroDoc']", false);
      }
    }),
    validarPaisNacimiento() {
      const nacionalidad = nacionalidades.find(
        n => n.label === this.model.lugarNacimiento
      )?.label;
      return nacionalidad ? null : "País no válido";
    }
  },
  mounted() {
    /* Si no hay oferta... Vuelvo a la consulta */
    if (PRODUCTION && !this.$store.state.dataOferta.oferta.valid) {
      this.$router.push("/");
    }

    // Autcompletado País de Nacimiento
    const { numeroDoc, nacionalidad } = this.$store.getters.getConsulta();
    if (Number(numeroDoc) < 90000000 || nacionalidad != "80") {
      this.model.lugarNacimiento =
        nacionalidades.find(item => item.value === nacionalidad)?.label ?? "";
    }

    if (this.$store.getters.getPaso1().cuil === "") {
      this.$store.getters.getPaso1().cuil = cuilGen(
        this.$store.getters.getConsulta().numeroDoc,
        this.$store.getters.getConsulta().sexo
      );
    }

    this.$store.watch(
      this.$store.getters.getPaso1,
      model => {
        this.model = model;
      },
      { immediate: true }
    );
  }
};
</script>

<style scoped>
p#subtitulo {
  margin-bottom: 40px;
}
p#titulo {
  margin-bottom: 5px;
}

@media screen and (max-width: 600px) {
  #titulo {
    font-size: 26px;
    margin-bottom: 10px;
  }
  .w100 {
    width: 100%;
  }
}

@media screen and (min-width: 601px) and (max-width: 1024px) {
  .w50 {
    width: 80%;
    max-width: 1024px;
    margin-left: 10%;
    margin-right: 10%;
  }

  .cascade {
    display: block;
  }

  .tablet {
    margin-left: 10%;
  }
}
</style>
